// Add scroll class to
(function () {
  const bodyClasses = document.body.classList;
  const tables = document.querySelectorAll('table');

  function addScrollClass() {
    bodyClasses.add('scrolling');
  }

  function removeScrollClass() {
    bodyClasses.remove('scrolling');
  }

  function responsiveTables(table, i) {
    const element = document.createElement('div');

    table.id = `table-${i}`;

    element.setAttribute('aria-labelledby', table.id);
    element.classList.add('table-wrapper');
    element.setAttribute('role', 'region');

    table.parentNode.insertBefore(element, table);

    element.appendChild(table);
  }

  tables.forEach((table, i) => responsiveTables(table, i));

  window.addEventListener('scroll', () => {
    window.scrollY === 0 ? requestAnimationFrame(removeScrollClass) : requestAnimationFrame(addScrollClass);
  });

  if (window.location.href.includes('.translate.goog') || window.location.href.includes('//translate.google.com')) {
    Array.from(document.querySelectorAll('.content__content a')).map((link) => {
      if (link.href.includes('//forms.office.com')) {
        const findURL = link.href.match(/u=(.*)&?/);
        const originalURL = findURL[1].replace('%3D', '=');

        link.href = originalURL;
      }
    });
  }

  if (document.querySelector('body.user-logged-in')) {
    const changeTop = (withActive) => {
      if (document.querySelector('body.toolbar-vertical')) {
        withActive = false;
      }

      const toolbarHeight = document.querySelector('#toolbar-bar').offsetHeight;
      const toolbarTrayHeight = document.querySelector('.toolbar-tray.is-active') ? document.querySelector('.toolbar-tray.is-active').offsetHeight : 39;

      document.querySelector('.header').style.top = `${withActive ? toolbarHeight + toolbarTrayHeight : toolbarHeight}px`;

      if (document.querySelector('.toolbar-oriented .toolbar-tray.is-active')) {
        document.querySelector('.toolbar-oriented .toolbar-tray.is-active').style.bottom = `-${toolbarTrayHeight}px`;
      }
    };

    setTimeout(() => changeTop(document.querySelectorAll('.toolbar-item.is-active').length > 0), 300);

    // when window changes width, run changeTop(document.querySelectorAll('.toolbar-item.is-active').length > 0) debounce it.
    window.addEventListener('resize', () => setTimeout(() => changeTop(document.querySelectorAll('.toolbar-item.is-active').length > 0), 300));

    document.querySelectorAll('.toolbar-item').forEach((item) => item.addEventListener('click', () => changeTop(!item.classList.contains('is-active'))));
  }
})();
